module.exports = __webpack_public_path__ + "img/altair.cec9569b.png";